<template>
  <v-alert v-if="somePendingRecreatePosition" color="softInfo" class="mb-2 mt-4">
    <v-progress-circular
      class="mb-1 mr-2 ml-1"
      size="15"
      width="2"
      indeterminate
    ></v-progress-circular>
    {{ $t(`views.common.somePendingRecreatePosition.incomplete`) }}
  </v-alert>
</template>

<script>
export default {
  props: {
    somePendingRecreatePosition: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
